define('IndicatorMessageView',[
    'backbone',
    'MessageView',
    'underscore',
    'jquery',
    'InternalLinkView',
    'template!blocks/messages/indicator',
    'app',
], function (Backbone, MessageView, _, $,
             InternalLinkView,
             IndicatorTemplate, app) {

    return MessageView.extend({
        render: function () {
            this.$el.html(IndicatorTemplate(this));
            this.show();
        },
        show: function () {
            var messageParentEl, view = this, prepend = false;
            switch (view.page) {
                case 'home':
                        messageParentEl = $('.address-autocomplete-container');
                    break;
                case 'listing':
                    if (app.isDesktop()) {
                        messageParentEl = $('.top-infos--container .right');
                    } else {
                        prepend = true;
                        messageParentEl = $('.cart-mobile');
                        view.$el.addClass('notifications indicator--mobile');
                    }
                    break;
                case 'shop':
                    messageParentEl = $('.store-notifications');
                    break;
                default:
                    return;
            }
            if(messageParentEl){
                var el = view.$el.get(0);
                if(prepend){
                    messageParentEl.prepend(el)
                }else{
                    messageParentEl.append(el)
                }
            }
            InternalLinkView.initializeLinksOfView(view);
        },
    });
});
